import React, { useState } from "react";
import { P_Props } from "./CareerForm.type";
import { Form, Field } from "react-final-form";
import { FormUtil, FormUIUtil, loadCallback, ImageUtil } from "../../../utils";
import { Loading, SimpleModalHeader, Notification, Pulse, CategoryCard1, ImageUpload } from "../../components";
import {
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Select,
  OutlinedInput,
  MenuItem,
  Checkbox,
  InputAdornment,
} from "@material-ui/core";
import {
  PriorityHigh as PriorityHighIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
  Event as EventIcon,
} from "@material-ui/icons";
import { FORM_MODE, CareerOutputModel, CityDataModel } from "../../../models";
import { COUNTRY, EducationOptions, CurrencyOptions } from "../../../constants";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

const CareerFormPresenter: React.FC<P_Props> = (props) => {
  let submit: any;
  const [visibleDeleteModal, setVisibleDeleteModal] = useState<boolean>(false);

  const toggleDeleteModal = () => {
    setVisibleDeleteModal(!visibleDeleteModal);
  };

  const bindingCareerDataToForm = (data: CareerOutputModel[]) => {
    const tempData: CareerOutputModel[] = data;
    const result = Object.assign(
      FormUtil.buildInitDataForm(tempData, [
        { key: "title" },
        { key: "jobDescription" },
        { key: "requirementsBenefits" },
        { key: "contactInformation" },
      ])
      // {
      //   maxSalary: currencyFormat(data[0].maxSalary!),
      //   minSalary: currencyFormat(data[0].minSalary!)
      // }
    );
    return result;
  };

  return (
    <>
      <div className="career-form">
        <SimpleModalHeader
          title={props.mode === FORM_MODE.CREATE ? "Create career" : "Edit career"}
          onClose={() => {
            props.onCancel();
          }}
        />
        <div className="career-form__divide">
          <div className="career-form__language">
            <h1>Language</h1>

            {props.languageOptions.map((lang) => {
              return (
                <CategoryCard1
                  key={lang.id}
                  name={lang.name}
                  onClick={() => {
                    props.onChangeLanguage(lang.id);
                  }}
                  picture={lang.image}
                  selected={props.activeLang === lang.id}
                  buildPictureSrc={ImageUtil.buildLanguageImgSrc}
                  isAvatar={true}
                />
              );
            })}
          </div>
          <div className="career-form__container">
            <div className="career-form__box">
              {props.loading && <Loading />}
              {!props.loading && (
                <Form
                  initialValues={
                    props.initData
                      ? bindingCareerDataToForm(props.initData)
                      : {
                          trackQuantity: true,
                        }
                  }
                  initialValuesEqual={() => true}
                  onSubmit={async (values, form) => {
                    props.onSubmit(values);
                  }}
                  render={({ handleSubmit, form, pristine, errors }) => {
                    submit = handleSubmit;

                    return (
                      <form onSubmit={handleSubmit}>
                        <Grid container spacing={4}>
                          <Grid item xs={8}>
                            {props.languageOptions.map((e) => {
                              return (
                                <div
                                  key={e.id}
                                  style={{
                                    display: props.activeLang === e.id ? "flex" : "none",
                                  }}
                                >
                                  <Field
                                    name={`title${e.id}`}
                                    validate={
                                      e.isPrimary ? FormUtil.Rule.required("This is required field") : undefined
                                    }
                                  >
                                    {({ input, meta, ...rest }) => {
                                      return FormUIUtil.renderFormItem(
                                        "Title",
                                        <TextField
                                          {...input}
                                          {...rest}
                                          fullWidth
                                          placeholder="Title"
                                          className="form-text-field"
                                          inputProps={{ className: "input" }}
                                          variant="outlined"
                                          onChange={(e) => input.onChange(e.target.value)}
                                          helperText={meta.touched ? meta.error : ""}
                                          error={meta.error && meta.touched}
                                        />,
                                        false,
                                        true
                                      );
                                    }}
                                  </Field>
                                </div>
                              );
                            })}
                          </Grid>
                          <Grid item xs={4}>
                            <Field name="vacancies">
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Vacancie",
                                  <TextField
                                    {...input}
                                    {...rest}
                                    type="number"
                                    fullWidth
                                    placeholder="Input vancancie"
                                    className="form-text-field"
                                    inputProps={{ className: "input" }}
                                    variant="outlined"
                                    helperText={meta.touched ? meta.error : ""}
                                    error={meta.error && meta.touched}
                                  />
                                );
                              }}
                            </Field>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4}>
                          <Grid item xs={12} lg={4}>
                            <Field name="country" validate={FormUtil.Rule.required("This is required field")}>
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Country",
                                  <Select
                                    {...input}
                                    {...rest}
                                    // native
                                    value={input.value}
                                    onChange={(e) => {
                                      input.onChange(e.target.value);
                                      form.change("city", undefined);
                                    }}
                                    error={meta.error && meta.touched}
                                    fullWidth
                                    input={<OutlinedInput className="form-text-field" />}
                                    variant="outlined"
                                    className="form-select-field"
                                    renderValue={
                                      props.mode === FORM_MODE.CREATE && !input.value
                                        ? () => (
                                            <span className="career-form__box__select-placeholder">
                                              Select a country
                                            </span>
                                          )
                                        : undefined
                                    }
                                    displayEmpty
                                  >
                                    {COUNTRY.map((country, index) => (
                                      <MenuItem key={index} value={country.countryName}>
                                        {country.countryName}
                                      </MenuItem>
                                    ))}
                                  </Select>,
                                  false,
                                  true
                                );
                              }}
                            </Field>
                          </Grid>
                          <Grid item xs={12} lg={4}>
                            <Field name="city">
                              {({ input, meta, ...rest }) => {
                                const selectedCountry = form.getFieldState("country")?.value;
                                const city: CityDataModel[] =
                                  COUNTRY.find((country) => country.countryName === selectedCountry)?.regions ||
                                  [];

                                return FormUIUtil.renderFormItem(
                                  "City",
                                  <Select
                                    {...input}
                                    {...rest}
                                    // native
                                    value={input.value}
                                    onChange={(e) => {
                                      input.onChange(e.target.value);
                                    }}
                                    error={meta.error && meta.touched}
                                    fullWidth
                                    input={<OutlinedInput className="form-text-field" />}
                                    variant="outlined"
                                    className="form-select-field"
                                    renderValue={
                                      props.mode === FORM_MODE.CREATE && !input.value
                                        ? () => (
                                            <span className="career-form__box__select-placeholder">
                                              Select a city
                                            </span>
                                          )
                                        : undefined
                                    }
                                    displayEmpty
                                  >
                                    {city.map((city, index) => (
                                      <MenuItem key={index} value={city.name}>
                                        {city.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                );
                              }}
                            </Field>
                          </Grid>

                          <Grid item xs={12} lg={4}>
                            <Field name="educationLevel">
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Education Level",
                                  <Select
                                    {...input}
                                    {...rest}
                                    // native
                                    value={input.value}
                                    // onChange={(e) => {
                                    //   input.onChange(e.target.value);
                                    //   form.change("city", undefined);
                                    // }}
                                    error={meta.error && meta.touched}
                                    fullWidth
                                    input={<OutlinedInput className="form-text-field" />}
                                    variant="outlined"
                                    className="form-select-field"
                                    renderValue={
                                      props.mode === FORM_MODE.CREATE && !input.value
                                        ? () => (
                                            <span className="career-form__box__select-placeholder">
                                              Select a level
                                            </span>
                                          )
                                        : undefined
                                    }
                                    displayEmpty
                                  >
                                    {EducationOptions.map((opt, index) => (
                                      <MenuItem key={index} value={opt.id}>
                                        {opt.label}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                );
                              }}
                            </Field>
                          </Grid>
                        </Grid>

                        <Grid container spacing={4}>
                          <Grid item xs={12} xl={4}>
                            <h2 className="career-salary">Salary range</h2>
                            <Grid container>
                              <Grid item xs={5}>
                                <Field name="minSalary">
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        type="number"
                                        fullWidth
                                        placeholder="Min"
                                        className="form-text-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        helperText={meta.touched ? meta.error : ""}
                                        error={meta.error && meta.touched}
                                        disabled={props.isEditSalary ? false : true}
                                      />
                                    );
                                  }}
                                </Field>
                              </Grid>{" "}
                              <span className="career-salary-divide">-</span>
                              <Grid item xs={5}>
                                <Field name="maxSalary">
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "  ",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        type="number"
                                        fullWidth
                                        placeholder="Max"
                                        className="form-text-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        helperText={meta.touched ? meta.error : ""}
                                        error={meta.error && meta.touched}
                                        disabled={props.isEditSalary ? false : true}
                                      />
                                    );
                                  }}
                                </Field>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} xl={4}>
                            <Field name="currency">
                              {({ input, meta, ...rest }) => {
                                return FormUIUtil.renderFormItem(
                                  "Currency",
                                  <Select
                                    {...input}
                                    {...rest}
                                    // native
                                    value={input.value}
                                    // onChange={(e) => {
                                    //   input.onChange(e.target.value);
                                    //   form.change("city", undefined);
                                    // }}
                                    error={meta.error && meta.touched}
                                    fullWidth
                                    input={<OutlinedInput className="form-text-field" />}
                                    variant="outlined"
                                    className="form-select-field"
                                    renderValue={
                                      props.mode === FORM_MODE.CREATE && !input.value
                                        ? () => (
                                            <span className="career-form__box__select-placeholder">
                                              Select a currency
                                            </span>
                                          )
                                        : undefined
                                    }
                                    displayEmpty
                                    disabled={props.isEditSalary ? false : true}
                                  >
                                    {CurrencyOptions.map((opt, index) => (
                                      <MenuItem className="career-currency-popover" key={index} value={opt.id}>
                                        {opt.name} <span className="career-currency-popover__right">{opt.id}</span>
                                      </MenuItem>
                                    ))}
                                  </Select>
                                );
                              }}
                            </Field>
                          </Grid>
                          <Grid item xs={12} xl={4} className="career-form__box__showSalary">
                            <Checkbox
                              className="app-check-box"
                              checked={props.isEditSalary}
                              onChange={(e) => {
                                const isChecked = e.target.checked;
                                props.onChangeEditSalaryStatus(isChecked);
                              }}
                              icon={<CheckBoxOutlineBlankIcon style={{ fontSize: "2.2rem" }} />}
                              checkedIcon={<CheckBoxIcon style={{ fontSize: "2.2rem" }} />}
                            />{" "}
                            <span>Show Salary Range </span>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          {FormUIUtil.renderFormItem(
                            "Upload Image",
                            <>
                              <ImageUpload
                                className="focusedMarket-form__avatar"
                                fileList={props.careerPictures}
                                max={1}
                                onChange={props.onUploadAvatar}
                                onDelete={props.onRemoveAvatar}
                                config={{ uploadModal: true }}
                              />
                              <p className="focusedMarket-form__avatar--note">
                                The image size should be smaller than 500KB
                              </p>
                            </>, false, true
                          )}
                        </Grid>
                        {props.languageOptions.map((e) => {
                          return (
                            <Grid
                              key={e.id}
                              style={{
                                display: props.activeLang === e.id ? "flex" : "none",
                              }}
                              container
                              spacing={4}
                            >
                              <Grid item xs={12} lg={12}>
                                <Field
                                  name={`jobDescription${e.id}`}
                                  validate={
                                    e.isPrimary ? FormUtil.Rule.required("Please input job description") : undefined
                                  }
                                >
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "Role and Responsibilities",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        fullWidth
                                        multiline
                                        rows={7}
                                        placeholder="How would you describe this job?"
                                        className="form-textarea-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        onChange={(e) => input.onChange(e.target.value)}
                                        helperText={meta.touched ? meta.error : ""}
                                        error={meta.error && meta.touched}
                                      />,
                                      false,
                                      true
                                    );
                                  }}
                                </Field>
                              </Grid>
                              <Grid item xs={12} lg={12}>
                                <Field name={`requirementsBenefits${e.id}`}>
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "Requirements & Benefits",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        fullWidth
                                        multiline
                                        rows={7}
                                        placeholder="What are jobs requirements?"
                                        className="form-textarea-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        onChange={(e) => input.onChange(e.target.value)}
                                      />
                                    );
                                  }}
                                </Field>
                              </Grid>
                              <Grid item xs={12} lg={12}>
                                <Field name={`contactInformation${e.id}`}>
                                  {({ input, meta, ...rest }) => {
                                    return FormUIUtil.renderFormItem(
                                      "Contact Information",
                                      <TextField
                                        {...input}
                                        {...rest}
                                        fullWidth
                                        multiline
                                        placeholder="HR Information / Multiple"
                                        className="form-textarea-field"
                                        inputProps={{ className: "input" }}
                                        variant="outlined"
                                        onChange={(e) => input.onChange(e.target.value)}
                                      />
                                    );
                                  }}
                                </Field>
                              </Grid>
                            </Grid>
                          );
                        })}

                        <Grid container spacing={4}>
                          <Grid item xs={6} lg={4}>
                            {FormUIUtil.renderFormItem(
                              "Closing Date",
                              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <DateTimePicker
                                  ampm={false}
                                  inputVariant="outlined"
                                  value={props.careerStatus.timePublication}
                                  onChange={(value) => {
                                    if (value) {
                                      props.onChangeTimePublication(value.toISOString());
                                    }
                                  }}
                                  format="dd/MM/yyyy hh:mm a"
                                  className="form-text-field"
                                  fullWidth
                                  inputProps={{ className: "input" }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <EventIcon style={{ fontSize: "2.2rem" }} />
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            )}
                          </Grid>
                          <Grid item xs={6} lg={4}>
                            {FormUIUtil.renderFormItem(
                              "Status",
                              <FormControlLabel
                                control={
                                  <Switch
                                    checked={props.careerStatus.status}
                                    onChange={(e) => {
                                      props.onChangeCareerStatus(e.target.checked);
                                    }}
                                    className="app-switch-box"
                                  />
                                }
                                label={
                                  <div className="form-label" style={{ marginBottom: 0 }}>
                                    Publish
                                  </div>
                                }
                              />
                            )}
                          </Grid>
                        </Grid>
                      </form>
                    );
                  }}
                />
              )}
            </div>
          </div>
        </div>
        <div className="career-form__footer">
          {props.mode !== FORM_MODE.CREATE && (
            <button
              className="btn delete"
              onClick={(e) => {
                e.preventDefault();
                toggleDeleteModal();
              }}
            >
              Delete
            </button>
          )}
          <button
            className="btn cancel"
            onClick={(e) => {
              e.preventDefault();
              props.onCancel();
            }}
          >
            Cancel
          </button>
          <button
            type="submit"
            className="btn save"
            onClick={(e) => {
              loadCallback(submit, e);
            }}
          >
            Save
          </button>
        </div>
      </div>
      <Notification
        visible={visibleDeleteModal}
        title="Delete career"
        subTitle="Are you sure you want to delete this career?"
        icon={
          <Pulse color={"red"}>
            <div className="notification-icon-box red">
              <PriorityHighIcon style={{ fontSize: "5rem", color: "#fff" }} />
            </div>
          </Pulse>
        }
        actions={
          <>
            <button
              className="career-form__delete-modal__actions__cancel"
              onClick={() => {
                toggleDeleteModal();
              }}
            >
              Cancel
            </button>
            <button
              className="career-form__delete-modal__actions__confirm"
              onClick={() => {
                toggleDeleteModal();
                props.onDeleteCareer();
              }}
            >
              Confirm
            </button>
          </>
        }
      />
    </>
  );
};

export default CareerFormPresenter;
